export default "__VITE_ASSET__Dgu8Bp3i__"